import React, { useEffect } from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import PrimaryButton from "../../../../../Buttons/PrimaryButton/PrimaryButton";
import SecondaryButton from "../../../../../Buttons/SecondaryButton/SecondaryButton";
import TertiaryButton from "../../../../../Buttons/TertiaryButton/TertiaryButton";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import StagedComchecksTable from "../StagedComchecksTable/StagedComchecksTable";
import { handleAltEnter } from "../../../../../../utils/keyboardShortcutHelpers";

export default function ComchecksStepThree({ 
  activeLoad,
  carrier,
  stagedComchecksArray,
  step,
  setStep,
  setComcheckToEdit,
  handleCancel,
  handleDeleteStagedComcheck
}) {

  const handleAddNew = () => {
    setComcheckToEdit({});
    setStep(1);
  };

  const handleSubmit = () => {
    setStep(4);
  };

  useEffect(() => {
    const handleKeyDown = (e) => {
      handleAltEnter(e, false, handleSubmit);
    };

    document.addEventListener("keydown", handleKeyDown);

    return function cleanup() {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
 
  return (
    <Box>
      <Box className="Accessorial-modal-form-row">
        <Typography variant="subhead2" color="black_solid.60">
          Verify the Carrier
        </Typography>
        <Typography variant="subhead1" color="black_solid.80" sx={{ marginTop: "6px"}}>
          {carrier.name}
        </Typography>
      </Box>
      <Box sx={{ margin: "30px 0"}}>
        <StagedComchecksTable 
          activeLoad={activeLoad} 
          stagedComchecksArray={stagedComchecksArray}
          setComcheckToEdit={setComcheckToEdit}
          step={step}
          setStep={setStep}
          handleDeleteStagedComcheck={handleDeleteStagedComcheck}
        />
      </Box>
      <Box sx={{ display: "flex", marginTop: "50px" }}>
        <Box sx={{ marginLeft: "auto" }}>
          <TertiaryButton 
            label="Add Comcheck"
            onClick={handleAddNew}
            startIcon={AddCircleIcon}
          />
        </Box>
      </Box>
      <Box sx={{ display: "flex", marginTop: "30px" }}>
        <Box sx={{ margin: "0 30px 0 auto"}}>
          <SecondaryButton
            id="cancel-button"
            label="Cancel"
            onClick={handleCancel}
          />
        </Box>
        <Box>
          <PrimaryButton
            id="submit-button"
            label="Submit All"
            onClick={handleSubmit}
          />
        </Box>
      </Box>
    </Box>
  );
}

ComchecksStepThree.propTypes = {
  activeLoad: PropTypes.object.isRequired,
  carrier: PropTypes.oneOfType([
    PropTypes.object,
    PropTypes.string
  ]),
  step: PropTypes.number,
  setStep: PropTypes.func,
  stagedComchecksArray: PropTypes.array.isRequired,
  setComcheckToEdit: PropTypes.func,
  handleCancel: PropTypes.func.isRequired,
  handleDeleteStagedComcheck: PropTypes.func
};